<template>
  <div class="p-4 lg:p-8">
    <div class="surface-card p-4 shadow-sm border border-iron rounded-lg mb-6 flex justify-between items-center bg-white">
      <div>
        <h2 class="text-2xl font-bold text-secondary">Gerador de Contrato Digital</h2>
        <p class="text-sm text-gray-500">Revise e altere as informações diretamente nos campos demarcados antes de exportar.</p>
      </div>
      <div class="flex gap-3">
        <Button 
          label="Voltar" 
          icon="pi pi-arrow-left" 
          @click="emit('back')" 
          class="p-button-outlined p-button-secondary px-4" 
        />
        <Button 
          label="Gerar PDF" 
          icon="pi pi-file-pdf" 
          @click="generatePDF" 
          :loading="exporting"
          class="bg-purple-suit-forced border-none px-4" 
        />
      </div>
    </div>

    <div class="flex justify-center">
      <div 
        ref="contractContainer" 
        class="bg-white p-12 shadow-md border border-iron rounded-lg text-justify font-sans text-black location-print"
        style="max-width: 800px; line-height: 1.6; font-size: 11pt;"
      >
        <h1 class="text-center font-bold text-2xl mb-8 uppercase tracking-wide">
          Contrato de Prestação de Serviços Educacionais
        </h1>

        <p class="mb-6">
          <span class="font-bold">CONTRATANTE:</span>
          <input v-model="form.name" type="text" class="inline-input font-bold" placeholder="[Nome Completo]" style="width: 250px;" />, 
          <input v-model="form.nacionality" type="text" class="inline-input" placeholder="[Nacionalidade]" style="width: 120px;" />, 
          <input v-model="form.occupation" type="text" class="inline-input" placeholder="[Profissão]" style="width: 140px;" />, 
          inscrita no CPF/CNPJ sob o nº <input v-model="form.document" type="text" class="inline-input" placeholder="[Documento]" style="width: 150px;" />, 
          residente e domiciliado(a) em <input v-model="form.address" type="text" class="inline-input" placeholder="[Endereço Completo]" style="width: 300px;" />.
        </p>

        <p class="mb-6">
          <span class="font-bold">CONTRATADA:</span>
          <span class="font-bold"> Escola de Idiomas Teacher Maestra Victoria</span>, inscrita no CNPJ sob o nº 65.617.262/0001-45, com sede em Rua João Alceu Fialla nº108, Parque da Fonte - 83050-315, São José dos Pinhais / Paraná.
        </p>

        <h3 class="font-bold text-lg mt-6 mb-2 uppercase text-gray-800">CLÁUSULA PRIMEIRA – DO OBJETO</h3>
        <p class="mb-6">
          O presente contrato tem por objeto a prestação de serviços de ensino do idioma <span class="font-bold">inglês</span>, através de aulas na modalidade <span class="font-bold">online ao vivo</span>, conforme o plano escolhido pelo CONTRATANTE.
        </p>

        <h3 class="font-bold text-lg mt-6 mb-2 uppercase text-gray-800">CLÁUSULA SEGUNDA – DA CARGA HORÁRIA E CRONOGRAMA</h3>
        <p class="mb-2">As aulas serão ministradas conforme o seguinte regime:</p>
        <ul class="list-disc pl-8 mb-6 space-y-1">
          <li><span class="font-bold">Frequência:</span> <input v-model="form.class_frequency" type="text" class="inline-input" placeholder="Ex: 2 vezes por semana" style="width: 200px;" />.</li>
          <li><span class="font-bold">Duração:</span> <input v-model="form.duration_in_minutes" type="number" class="inline-input text-center" placeholder="60" style="width: 60px;" /> minutos por aula.</li>
          <li><span class="font-bold">Horário:</span> <input v-model="form.class_time_text" type="text" class="inline-input" placeholder="Ex: Terças e Quintas, às 21h" style="width: 300px;" />.</li>
          <li><span class="font-bold">Plataforma (se online):</span> Google Meet.</li>
        </ul>

        <h3 class="font-bold text-lg mt-6 mb-2 uppercase text-gray-800">CLÁUSULA TERCEIRA – DO INVESTIMENTO E PAGAMENTO</h3>
        <p class="mb-2">
          Pela prestação dos serviços, o CONTRATANTE pagará à CONTRATADA o valor total de 
          <span class="font-bold">R$ </span><input v-model="form.total_value" type="text" class="inline-input font-bold text-center" style="width: 90px;" />, 
          dividido em <input v-model="form.installments" type="number" class="inline-input font-bold text-center" style="width: 50px;" /> parcelas de 
          <span class="font-bold">R$ </span><input v-model="form.installment_value" type="text" class="inline-input font-bold text-center" style="width: 80px;" />, 
          com vencimento todo dia <input v-model="form.payment_day" type="number" class="inline-input font-bold text-center" style="width: 50px;" /> de cada mês.
        </p>
        <p class="text-sm pl-4 border-l-2 border-gray-300 italic mb-6">
          <span class="font-bold">Parágrafo Único:</span> O atraso no pagamento sujeitará o CONTRATANTE à multa de 2% (dois por cento) sobre o valor da parcela, acrescida de juros de mora de 1% (um por cento) ao mês.
        </p>

        <h3 class="font-bold text-lg mt-6 mb-2 uppercase text-gray-800">CLÁUSULA QUARTA – DO MATERIAL DIDÁTICO</h3>
        <p class="mb-6">
          O custo do material didático <span class="font-bold">está</span> incluso no valor das mensalidades. Caso não esteja, a aquisição é de inteira responsabilidade do CONTRATANTE.
        </p>

        <h3 class="font-bold text-lg mt-6 mb-2 uppercase text-gray-800">CLÁUSULA QUINTA – DAS REPOSIÇÕES E FALTAS</h3>
        <ol class="list-decimal pl-8 mb-6 space-y-1">
          <li>Em caso de ausência do aluno, não haverá desconto no valor da mensalidade.</li>
          <li>A aula será considerada "dada" caso o aluno não compareça ou não avise com antecedência mínima de <span class="font-bold">36 horas</span>.</li>
          <li>Reposições serão concedidas apenas em casos de <span class="font-bold">doença comprovada</span>, sujeitas à disponibilidade de agenda da CONTRATADA.</li>
        </ol>

        <h3 class="font-bold text-lg mt-6 mb-2 uppercase text-gray-800">CLÁUSULA SEXTA – DA RESCISÃO E MULTA</h3>
        <p class="mb-2">O CONTRATANTE poderá rescindir este contrato a qualquer momento, mediante aviso prévio por escrito de 30 dias.</p>
        <ol class="list-decimal pl-8 mb-6 space-y-1">
          <li>Caso a rescisão ocorra antes do término do período contratado, será aplicada uma multa rescisória de <span class="font-bold">10% (dez por cento)</span> sobre o valor das parcelas restantes (vincendas).</li>
          <li>A CONTRATADA poderá rescindir o contrato em caso de inadimplência superior a <span class="font-bold">30 dias</span>.</li>
        </ol>

        <h3 class="font-bold text-lg mt-6 mb-2 uppercase text-gray-800">CLÁUSULA SÉTIMA – DIREITO DE IMAGEM</h3>
        <p class="mb-6">
          O CONTRATANTE autoriza o uso de sua imagem e voz em registros das aulas para fins de divulgação e materiais internos da CONTRATADA, sem que isso gere qualquer ônus ou direito a indenização.
        </p>

        <h3 class="font-bold text-lg mt-6 mb-2 uppercase text-gray-800">CLÁUSULA OITAVA – DO FORO E ASSINATURA DIGITAL</h3>
        <ol class="list-decimal pl-8 mb-6 space-y-1">
          <li>Este contrato é celebrado de forma <span class="font-bold">exclusivamente digital</span>. As partes reconhecem a validade, integridade e autenticidade das assinaturas realizadas através do portal <span class="font-bold">Gov.br</span>, conforme a Lei nº 14.063/2020.</li>
          <li>Para dirimir quaisquer controvérsias oriundas deste ajuste, as partes elegem o Foro da Comarca de <span class="font-bold">São José dos Pinhais - PR</span>, com renúncia expressa a qualquer outro, por mais privilegiado que seja.</li>
        </ol>

        <p class="mt-12 mb-16 uppercase font-bold text-sm tracking-wider">
          SÃO JOSÉ DOS PINHAIS - PARANÁ, <input v-model="form.current_day" type="text" class="inline-input text-center" style="width: 40px;" /> DE <input v-model="form.current_month" type="text" class="inline-input text-center" style="width: 100px;" /> DE <input v-model="form.current_year" type="text" class="inline-input text-center" style="width: 60px;" />.
        </p>

        <div class="mt-16 grid grid-cols-2 gap-12 text-center text-xs">
          <div>
            <hr class="border-black mb-2" />
            <p class="font-bold uppercase">Escola de Idiomas Teacher Maestra Victoria</p>
            <p class="text-gray-500">CONTRATADA</p>
          </div>
          <div>
            <hr class="border-black mb-2" />
            <p class="font-bold uppercase">{{ form.name || '[NOME DO CONTRATANTE]' }}</p>
            <p class="text-gray-500">CONTRATANTE</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, defineProps, defineEmits, reactive } from 'vue';
import Button from 'primevue/button';
import html2pdf from 'html2pdf.js';

const props = defineProps({
  student: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['back']);
const contractContainer = ref(null);
const exporting = ref(false);

const form = reactive({
  name: '',
  nacionality: '',
  occupation: '',
  document: '',
  address: '',
  class_frequency: '',
  duration_in_minutes: '',
  class_time_text: '',
  payment_day: '',
  total_value: '4800,00',
  installments: 12,
  installment_value: '400,00',
  current_day: '',
  current_month: '',
  current_year: ''
});

onMounted(() => {
  if (props.student) {
    form.name = props.student.name || '';
    form.nacionality = props.student.nacionality || '';
    form.occupation = props.student.occupation || '';
    form.document = props.student.document || '';
    form.address = props.student.address || '';
    form.class_frequency = props.student.class_frequency || '2 vezes por semana';
    form.duration_in_minutes = props.student.duration_in_minutes || 60;
    form.payment_day = props.student.payment_day || 10;
    
    if (props.student.class_time) {
      try {
        const schedules = typeof props.student.class_time === 'string' 
          ? JSON.parse(props.student.class_time) 
          : props.student.class_time;
        
        if (Array.isArray(schedules) && schedules.length > 0) {
          form.class_time_text = schedules.map(h => `${h.day} às ${h.start}`).join(', ');
        }
      } catch (e) {
        form.class_time_text = '';
      }
    }
  }

  const today = new Date();
  const months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
  form.current_day = String(today.getDate()).padStart(2, '0');
  form.current_month = months[today.getMonth()].toUpperCase();
  form.current_year = String(today.getFullYear());
});

const generatePDF = () => {
  exporting.value = true;
  
  const options = {
    margin: [15, 15, 15, 15], 
    filename: `Contrato_${form.name.replace(/\s+/g, '_')}.pdf`,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2, useCORS: true, logging: false },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  };

  html2pdf().set(options).from(contractContainer.value).save().then(() => {
    exporting.value = false;
  }).catch((err) => {
    console.error("Erro ao gerar PDF:", err);
    exporting.value = false;
  });
};
</script>

<style scoped>
/* Estilização para fazer o input parecer texto corrido, mas editável */
.inline-input {
  border: none;
  border-bottom: 1px dashed #a0aec0;
  background-color: #f7fafc;
  padding: 0px 4px;
  color: #1a202c;
  font-family: inherit;
  font-size: inherit;
}

.inline-input:focus {
  outline: none;
  border-bottom: 2px solid #6b46c1; /* Cor aproximada do purple-suit */
  background-color: #fff;
}

/* Remove setas de inputs do tipo number */
.inline-input::-webkit-outer-spin-button,
.inline-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Estilos de impressão específicos para quando gerar o PDF esconder bordas e fundos dos inputs */
@media print {
  .location-print {
    box-shadow: none !important;
    border: none !important;
    padding: 0 !important;
  }
}
</style>